import { ETransportTrainLiterals } from "services/util/trips.service";
import { externalBuy, includedMainText } from "./functions/managePricetag";
import { switchTransports } from "./TripSelector.service";
import { convertLegIdsToNumbers } from "./TripSelector.util";

/** [AVE][CERCANIAS]
 *  El usuario puede comprar una ruta con Cercanías y AVE:
 *  - El billete de AVE siempre incluye un trayecto de Cercanías**
 *  - Este trayecto puede incluir transbordos. Ej.: Orcasitas - Atocha (C5), Atocha - Chamartín (C3), Chamartín - Alicante (AVE) ambos trayectos de Cercanías están incluidos en billete de AVE
 *  - Si hay múltiples trayectos de Cercanías en la ruta incluirá el primero
 *  - Si el usuario elimina el trayecto de Cercanías incluido en el AVE, se incluirá el siguiente trayecto en Cercanías.
 *  - El resto de trayectos no incluidos deberán mostrar su precio en caso de tenerlo (si no lo tienen pondrá que requiere compra externa)
 *  - Si el usuario elimina el trayecto en AVE, no habrá ningún Cercanías incluido en el billete y todos deben mostrar su precio (o requiere compra externa en caso de no tenerlo).
 * @param indexDeleteItem Posicion del PST a eliminar
 * @param detailsSelector Array del detalle de ruta que contiene transbordos
 * @param t Función de traducciones i18n
 * @returns Array del detalle de ruta modificado
 */
export function manageDeleteAveCercanias(
  indexDeleteItem: number,
  detailsSelector: Array<any>,
  t: Function
) {
  const idxDelete = indexDeleteItem;
  const trayecto = [...detailsSelector];

  const hasAve = trayecto.find((pst) => pst.icon === "ave");
  const hasCer = trayecto.find((pst) => pst.icon === "cercanias");

  const deleteAve = trayecto[idxDelete]?.icon === "ave";
  const deleteCer = trayecto[idxDelete]?.icon === "cercanias";
  // El primer cercanias (que no sea el que vayamos a eliminar).
  const firstCercaniasIndex = trayecto.findIndex(
    (pst) =>
      pst.icon === "cercanias" && trayecto[idxDelete]?.idPst !== pst.idPst
  );

  /* Hay AVE y estoy eliminando AVE */
  if (hasAve && deleteAve) {
    //Si el ave tiene antes un ingreso se borra
    if (detailsSelector[idxDelete - 1]?.icon === "ingreso") {
      const index = idxDelete - 1;
      trayecto[index].deleted = true;
      // trayecto.splice(index, 2);
    } else {
      trayecto[idxDelete].deleted = true;
      // trayecto.splice(idxDelete, 1);
    }

    // Si despues del borrado del ave, no quedan más aves, se cambia el precio informativo del cercanias si era "Billete incluido".
    const hasMoreAves = trayecto.find(
      (pst) => pst.icon === "ave" && trayecto[idxDelete]?.idPst !== pst.idPst
    );
    if (!hasMoreAves && firstCercaniasIndex >= 0) {
      const tag = trayecto[firstCercaniasIndex]?.pricetag;

      // TODO: revisar, probablemente no hay que usar un if, meter realpricetag en pricetag y ya.
      if (
        tag.type === "info" &&
        tag.text === t("literals.mainTicketIncluded")
      ) {
        trayecto[firstCercaniasIndex].pricetag =
          trayecto[firstCercaniasIndex].realPriceTag;
      }
    }
  }

  /* Hay AVE y estoy eliminando un Cercanias */
  if (hasAve && !deleteAve && hasCer && deleteCer && firstCercaniasIndex >= 0) {
    trayecto[firstCercaniasIndex].pricetag = includedMainText(t);
  }

  /* No hay AVE y estoy eliminando un Cercanias */
  if (!hasAve && hasCer && deleteCer) {
    const countCercanias = (
      trayecto.filter((pst) => pst.icon === "cercanias") || []
    )?.length;
    const tag = trayecto[firstCercaniasIndex]?.pricetag;
    const realPriceTag = trayecto[firstCercaniasIndex]?.realPriceTag;

    //Comprobamos si delante de la ruta seleccionada o atras hay un cercnias
    if (
      detailsSelector[idxDelete]?.icon === "cercanias" &&
      (detailsSelector[idxDelete - 1]?.icon === "cercanias" ||
        detailsSelector[idxDelete + 1]?.icon === "cercanias")
    ) {
      if(firstCercaniasIndex===1 && trayecto[firstCercaniasIndex].idTariff===undefined  ){
          trayecto[firstCercaniasIndex].pricetag= externalBuy(t,realPriceTag?.price);
      }else{
     return detailsSelector;
      }
 
    } else {
      /* Quedan más cercanías aún */
      if (countCercanias > 2) {
        if (tag?.type === "button" && realPriceTag?.price > 0) {
          trayecto[firstCercaniasIndex].pricetag = includedMainText(t);
        }
      }
      // Solo va a quedar 1 cercanias despues del borrado.
      else {
        if (
          tag?.type === "info" &&
          tag?.text === t("literals.mainTicketIncluded") &&
          realPriceTag?.price > 0
        ) {
          trayecto[firstCercaniasIndex].pricetag =
            trayecto[firstCercaniasIndex].realPriceTag;
        } else if (realPriceTag?.price === 0) {
          trayecto[firstCercaniasIndex].pricetag = externalBuy(
            t,
            realPriceTag?.price
          ); // ¿"compra externa" o "tarifa no disponsible"?
        }
      }
    }
  }
  return trayecto;
}

/** [AVE]
 * @param trip Contiene la ruta completa del viaje (contiene varios PST's)
 * @param travellersList Pasajeros incluidos en la búsqueda del planificador
 * @returns Devuelve un Array que contiene la posición del PST que contiene coche en silencio.
 */
export function getSilentObject(
  trip: any,
  travellersList: any
): Array<{ index: any; isSilent: any }> {
  const passengerObj = travellersList?.value;
  const babyCount = passengerObj["less-than-3-counter"];
  const childCount = passengerObj["less-than-13-counter"];

  return trip?.TariffResult?.fareSetItem?.map((item: any) => {
    const key = item?.fromLegId;
    const auxItem = !!item?.fareItem ? item?.fareItem[0] : [];
    const silentCar = auxItem?.param?.find(
      (param: any) => param?.name == "SILENT_CAR"
    );
    return {
      index: key,
      isSilent:
        silentCar?.value === "true" && babyCount === 0 && childCount === 0,
    };
  });
}

/** [CERCANIAS]
 * Método específico para transformar trip en mdetailroute. Se llama desde la función mapTripToDetail.
 * @param trip Contiene la ruta completa del viaje (contiene varios PST's)
 * @param index Indice del pst mapeado
 * @returns {Object} Devuelve si el pst es un transbordo o es un cercanias con billete incluido de AVE.
 */
export function manageTransbordosCercanias(trip: any, index: number) {
  /* Transbordo entre cercanias */
  let isTransbordo: boolean = false;
  let isIncludedByAve: boolean = false;
  /* GESTION DE TRANSBORDO */
  const previousTwoSteps =
    trip.LegList.Leg[index - 2] &&
    switchTransports(trip.LegList.Leg[index - 2], trip);
  const previousStep =
    trip.LegList.Leg[index - 1] &&
    switchTransports(trip.LegList.Leg[index - 1], trip);
  isTransbordo =
    /* Si en dos pasos anteriores es un cercanias y luego un transbordo a pie */
    previousTwoSteps && previousTwoSteps.icon == "cercanias"
      ? previousTwoSteps.icon == "cercanias" &&
        (previousStep.icon == "andar" ||
          previousStep.icon == "transbordo" ||
          previousStep.icon == "cercanias")
      : /* Si no hay dos pasos anteriores, simplemente el paso anterior es un cercanias */
      previousStep
      ? previousStep.icon == "cercanias"
      : false;

  if (
    previousTwoSteps &&
    previousTwoSteps.icon == "ingreso" &&
    previousStep &&
    previousStep.icon === "ave"
  ) {
    isTransbordo = true;
  } else if (
    previousTwoSteps &&
    previousTwoSteps.icon == "ave" &&
    previousStep &&
    previousStep.icon === "andar"
  ) {
    isTransbordo = true;
  }
  /* Si hay un AVE, el primer cercanias tiene que estar incluido. */
  const transports: Array<any> = trip.LegList.Leg.map(switchTransports);

  // CombinadoCercanías permite, con la compra de un billete AVE, Alvia, Euromed o Intercity
  const hasAve = transports.find(
    (item) =>
      item.icon === "ave" &&
      item.transportTypeString !== ETransportTrainLiterals.avlo
  );
  if (!!hasAve) {
    const firstCercanias = transports.findIndex(
      (item) => item.icon === "cercanias"
    );
    if (firstCercanias == index) {
      if (trip?.TariffResult && Object.entries(trip.TariffResult).length !== 0) {
        let isCercaniasTariff = trip?.TariffResult?.fareSetItem.find(
          (item: any) => convertLegIdsToNumbers(item.fromLegId) === transports[firstCercanias].idx
        );
        if (!isCercaniasTariff) {
          isIncludedByAve = true;
        } else {
          isIncludedByAve = false;
          isTransbordo = false;
        }
      }
    } else if (
      transports[index - 1]?.icon === "ave" &&
      transports[index]?.icon === "cercanias"
    ) {
      //Si el paso anterior es un ave y despues de un cercanias el cercanias va con el ave en el billete
      isIncludedByAve = true;
    }
  }

  return { isTransbordo, isIncludedByAve };
}

export function mappingDelete(data: any) {
  
  return data.map((item: any, index: any, arr: any) => {
    // Primera condición: todos los valores son "cercanias"
    const allCercanias = arr.every((obj: any) => obj.icon === "cercanias");
    if (allCercanias) {
      return { ...item, delete: false };
    }

    // Segunda condición: un "cercanias" seguido de otro "cercanias" y luego algo diferente
    const isFirstCercaniasWithDifferentAfter =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index + 1]?.icon === "cercanias" && // Siguiente también es "cercanias"
      arr[index + 2]?.icon !== "cercanias"; // Dos posiciones adelante NO es "cercanias"
    if (isFirstCercaniasWithDifferentAfter) {
      return { ...item, delete: true };
    }

    const isNextCercaniasInSequence =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index - 1]?.icon === "cercanias" && // Previo también es "cercanias"
      arr[index + 1]?.icon !== "cercanias"; // Siguiente NO es "cercanias"
    if (isNextCercaniasInSequence) {
      return { ...item, delete: false };
    }

    // Nueva condición: "cercanias" seguidos
    const isFirstCercaniasInSequence =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index - 1]?.icon !== "cercanias"; // Previo no es "cercanias"
    const isCercaniasSequenceContinues =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index + 1]?.icon === "cercanias"; // Siguiente también es "cercanias"
    const isAfterLastCercanias =
      arr[index - 1]?.icon === "cercanias" && // Previo es "cercanias"
      item.icon !== "cercanias"; // Actual no es "cercanias"

      const isMid =
      arr[index - 1]?.icon  && // Previo es "cercanias"
      item.icon  &&   arr[index + 1]?.icon ; // Actual no es "cercanias"

    if (isFirstCercaniasInSequence) {
      return { ...item, delete: true }; // Primer "cercanias" en secuencia
    }
    if (isCercaniasSequenceContinues) {
      return { ...item, delete: false }; // Resto de "cercanias" en secuencia
    }
    if (isMid) {
      return { ...item, delete: false }; // Resto de "cercanias" en secuencia
    }
    
    if (isAfterLastCercanias) {
      return { ...item, delete: true }; // Después del último "cercanias"
    }
    //cuando solo quede un transporte en el array
    if (arr.length === 1) {
      return { ...item, delete: false }; // Único transporte
    }

    // Tercera condición: no cumple ninguna de las anteriores
    return { ...item, delete: true };
  });
}

// Function to check if all relevant objects are "cercanias"
const areAllCercanias = (data:any) => {
  // Filter out objects with the icon "andar"
  const arr = data.filter((obj:any) => obj.icon !== "andar" && obj.icon !== "ingreso");

  // Check if all remaining objects have the icon "cercanias"
  const onlyCercanias=arr.every((obj:any) => obj.icon === "cercanias");
  return {onlyCercanias,arr};
};

export function mappingDeleteAfter(data: any) {
  return data.map((item: any, index: any, all: any) => {
    // Primera condición: todos los valores son "cercanias"
    //const allCercanias = arr.every((obj: any) => obj.icon === "cercanias");
    const {onlyCercanias,arr} = areAllCercanias(all);
    
    if (onlyCercanias) {
      if(item?.isExternal===false){
        if(arr.length===1){
          return { ...item, showFooter: false };
        }else{
          return { ...item, showFooter: true };
        }
      }else{
        if(arr.length===1){
          return { ...item, showFooter: false };
        }else{
          return { ...item, showFooter: true };
        }
      }
    }

    // Segunda condición: un "cercanias" seguido de otro "cercanias" y luego algo diferente
    const isFirstCercaniasWithDifferentAfter =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index + 1]?.icon === "cercanias" && // Siguiente también es "cercanias"
      arr[index + 2]?.icon !== "cercanias"; // Dos posiciones adelante NO es "cercanias"
    if (isFirstCercaniasWithDifferentAfter) {
      if(item?.isExternal===false){
        return { ...item, showFooter: true };
      }else{
        return { ...item, showFooter: false };
      }
    }

    const isNextCercaniasInSequence =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index - 1]?.icon === "cercanias" && // Previo también es "cercanias"
      arr[index + 1]?.icon !== "cercanias"; // Siguiente NO es "cercanias"
    if (isNextCercaniasInSequence) {
      if(item?.isExternal===false){
        return { ...item, showFooter: true };
      }else{
        return { ...item, showFooter: false };
      }

    }

    // Nueva condición: "cercanias" seguidos
    const isFirstCercaniasInSequence =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index - 1]?.icon !== "cercanias"; // Previo no es "cercanias"
    const isCercaniasSequenceContinues =
      item.icon === "cercanias" && // Actual es "cercanias"
      arr[index + 1]?.icon === "cercanias"; // Siguiente también es "cercanias"
    const isAfterLastCercanias =
      arr[index - 1]?.icon === "cercanias" && // Previo es "cercanias"
      item.icon !== "cercanias"; // Actual no es "cercanias"

    const isAfterLastAny =
      arr[index - 1]?.icon === "andar" && // Previo es no existe
      item.icon !== "cercanias" && // Actual es "cercanias"
      arr[index + 1]?.icon === undefined; //Actual es any

    const condicionRara =  arr[0]?.icon === "andar" && arr[0]?.icon !== "cercanias" && arr.length===2
    if (isFirstCercaniasInSequence) {
      return { ...item, showFooter: true }; // Primer "cercanias" en secuencia
    }
    if (isCercaniasSequenceContinues) {
      return { ...item, showFooter: false }; // Resto de "cercanias" en secuencia
    }
    if (isAfterLastCercanias) {
      return { ...item, showFooter: true }; // Después del último "cercanias"
    }
    if (condicionRara) {
      return { ...item, showFooter: false }; // Después del último "any"
    }
    

    if (isAfterLastAny) {
      return { ...item, showFooter: true }; // Después del último "any"
    }
    //  cuando solo quede un transporte en el array
    if (arr.length === 1) {
      return { ...item, showFooter: false }; // Único transporte
    }
    // Tercera condición: no cumple ninguna de las anteriores
    //return { ...item, showFooter: true };
      // Correct logic: use the filtered array indices
      const filteredIndex = arr.findIndex((filteredItem:any) => filteredItem === item);

      if (filteredIndex === 0 || filteredIndex === arr.length - 1) {
        return { ...item, showFooter: true }; // First or last item in filtered array
      } else {
        return { ...item, showFooter: false }; // Not the first or last item in filtered array
      }
  });
}
